import { ExperimentBase } from "./experiment-base";

export class NotesApp extends ExperimentBase {
  private navigationManager: any;

  constructor() {
    super({
      id: "notes",
      title: "About These Experiments",
      tagline: "Experiments in local AI models and AI safety",
    });
  }

  public init(llm: any): void {
    // Notes page doesn't need LLM
  }

  public setNavigationManager(nav: any): void {
    this.navigationManager = nav;
  }

  protected setupContent(): void {
    // Content is static in HTML, just add click handlers
    this.addExperimentCardHandlers();
  }

  public activate(): void {
    this.addExperimentCardHandlers();
  }

  private addExperimentCardHandlers(): void {
    // Add click handlers to experiment cards
    const cards = document.querySelectorAll(".experiment-card");
    console.log("Found experiment cards:", cards.length);
    cards.forEach((card, index) => {
      const title = card.querySelector(".experiment-title")?.textContent;
      console.log(`Card ${index}: ${title}`);
      card.removeEventListener("click", this.handleCardClick); // Remove existing listener
      card.addEventListener("click", this.handleCardClick);
      
      // Also add touch event for mobile
      card.addEventListener("touchend", (e) => {
        e.preventDefault();
        this.handleCardClick(e);
      });
    });
  }

  private handleCardClick = (e: Event) => {
    const card = e.currentTarget as HTMLElement;
    const title = card.querySelector(".experiment-title")?.textContent;
    
    console.log("Card clicked with title:", title);

    let experimentId = "";
    if (title?.includes("Gameshow")) {
      experimentId = "gameshow";
    } else if (title?.includes("Versus")) {
      experimentId = "versus";
    } else if (title?.includes("Safety Q&A")) {
      experimentId = "safety-qa";
    } else if (title?.includes("Pong")) {  // Just check for "Pong" instead of "MURD Pong"
      experimentId = "pong";
    } else if (title?.includes("MURD&D")) {
      experimentId = "murdnd";
    }
    
    console.log("Switching to experiment:", experimentId);

    if (experimentId && this.navigationManager) {
      this.navigationManager.switchExperiment(experimentId);
    }
  };
}
